/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../ClientApp/app/app.browser.module';
import * as i2 from '../../../ClientApp/app/app.component';
import * as i3 from './pages/island-energy/island-energy.component.ngfactory';
import * as i4 from './pages/my-energy/my-energy.component.ngfactory';
import * as i5 from './pages/mobile-energy/mobile-energy.component.ngfactory';
import * as i6 from './pages/login/login.component.ngfactory';
import * as i7 from './pages/logout/logout.component.ngfactory';
import * as i8 from './app.component.ngfactory';
import * as i9 from '@angular/common';
import * as i10 from '@angular/platform-browser';
import * as i11 from '@angular/forms';
import * as i12 from '@angular/router';
import * as i13 from '../../../ClientApp/app/_shared/services/globals';
import * as i14 from '../../../ClientApp/app/_shared/services/msal.service';
import * as i15 from '../../../ClientApp/app/_shared/services/config.service';
import * as i16 from '../../../ClientApp/app/_shared/guards/msal.guard';
import * as i17 from '../../../ClientApp/app/_shared/services/energy-data.service';
import * as i18 from '@angular/http';
import * as i19 from '../../../ClientApp/app/_shared/services/monitoring.service';
import * as i20 from '../../../ClientApp/app/_shared/services/config.serviceFactory';
import * as i21 from 'ng2-nvd3/build/lib/ng2-nvd3.module';
import * as i22 from '../../../ClientApp/app/pages/island-energy/island-energy.component';
import * as i23 from '../../../ClientApp/app/pages/my-energy/my-energy.component';
import * as i24 from '../../../ClientApp/app/pages/mobile-energy/mobile-energy.component';
import * as i25 from '../../../ClientApp/app/pages/login/login.component';
import * as i26 from '../../../ClientApp/app/pages/logout/logout.component';
import * as i27 from '../../../ClientApp/app/app.shared.module';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = i0.ɵcmf(i1.AppModule,
    [i2.AppComponent],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.IslandEnergyComponentNgFactory,i4.MyEnergyComponentNgFactory,i5.MobileEnergyComponentNgFactory,
              i6.LoginComponentNgFactory,i7.LogoutComponentNgFactory,i8.AppComponentNgFactory]],
              [3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(5120,i0.LOCALE_ID,
          i0.ɵm,[[3,i0.LOCALE_ID]]),i0.ɵmpd(4608,i9.NgLocalization,i9.NgLocaleLocalization,
          [i0.LOCALE_ID]),i0.ɵmpd(5120,i0.APP_ID,i0.ɵf,([] as any[])),i0.ɵmpd(5120,
          i0.IterableDiffers,i0.ɵk,([] as any[])),i0.ɵmpd(5120,i0.KeyValueDiffers,
          i0.ɵl,([] as any[])),i0.ɵmpd(4608,i10.DomSanitizer,i10.ɵe,[i10.DOCUMENT]),
          i0.ɵmpd(6144,i0.Sanitizer,(null as any),[i10.DomSanitizer]),i0.ɵmpd(4608,
              i10.HAMMER_GESTURE_CONFIG,i10.HammerGestureConfig,([] as any[])),i0.ɵmpd(5120,
              i10.EVENT_MANAGER_PLUGINS,(p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
                return [new i10.ɵDomEventsPlugin(p0_0),new i10.ɵKeyEventsPlugin(p1_0),
                    new i10.ɵHammerGesturesPlugin(p2_0,p2_1)];
              },[i10.DOCUMENT,i10.DOCUMENT,i10.DOCUMENT,i10.HAMMER_GESTURE_CONFIG]),
          i0.ɵmpd(4608,i10.EventManager,i10.EventManager,[i10.EVENT_MANAGER_PLUGINS,
              i0.NgZone]),i0.ɵmpd(135680,i10.ɵDomSharedStylesHost,i10.ɵDomSharedStylesHost,
              [i10.DOCUMENT]),i0.ɵmpd(4608,i10.ɵDomRendererFactory2,i10.ɵDomRendererFactory2,
              [i10.EventManager,i10.ɵDomSharedStylesHost]),i0.ɵmpd(6144,i0.RendererFactory2,
              (null as any),[i10.ɵDomRendererFactory2]),i0.ɵmpd(6144,i10.ɵSharedStylesHost,
              (null as any),[i10.ɵDomSharedStylesHost]),i0.ɵmpd(4608,i0.Testability,
              i0.Testability,[i0.NgZone]),i0.ɵmpd(4608,i10.Meta,i10.Meta,[i10.DOCUMENT]),
          i0.ɵmpd(4608,i10.Title,i10.Title,[i10.DOCUMENT]),i0.ɵmpd(4608,i11.ɵi,i11.ɵi,
              ([] as any[])),i0.ɵmpd(5120,i12.ActivatedRoute,i12.ɵf,[i12.Router]),
          i0.ɵmpd(4608,i12.NoPreloading,i12.NoPreloading,([] as any[])),i0.ɵmpd(6144,
              i12.PreloadingStrategy,(null as any),[i12.NoPreloading]),i0.ɵmpd(135680,
              i12.RouterPreloader,i12.RouterPreloader,[i12.Router,i0.NgModuleFactoryLoader,
                  i0.Compiler,i0.Injector,i12.PreloadingStrategy]),i0.ɵmpd(4608,i12.PreloadAllModules,
              i12.PreloadAllModules,([] as any[])),i0.ɵmpd(5120,i12.ROUTER_INITIALIZER,
              i12.ɵi,[i12.ɵg]),i0.ɵmpd(5120,i0.APP_BOOTSTRAP_LISTENER,(p0_0:any) => {
            return [p0_0];
          },[i12.ROUTER_INITIALIZER]),i0.ɵmpd(4608,i13.Globals,i13.Globals,([] as any[])),
          i0.ɵmpd(4608,i14.MsalService,i14.MsalService,[i15.ConfigService]),i0.ɵmpd(4608,
              i16.MsalGuard,i16.MsalGuard,[i12.Router,i14.MsalService]),i0.ɵmpd(4608,
              i17.EnergyDataService,i17.EnergyDataService,[i18.Http,i14.MsalService,
                  'BASE_URL']),i0.ɵmpd(4608,i19.MonitoringService,i19.MonitoringService,
              [i15.ConfigService,i14.MsalService]),i0.ɵmpd(512,i9.CommonModule,i9.CommonModule,
              ([] as any[])),i0.ɵmpd(1024,i0.ErrorHandler,i10.ɵa,([] as any[])),i0.ɵmpd(1024,
              i0.NgProbeToken,() => {
                return [i12.ɵb()];
              },([] as any[])),i0.ɵmpd(512,i12.ɵg,i12.ɵg,[i0.Injector]),i0.ɵmpd(512,
              i18.BrowserXhr,i18.BrowserXhr,([] as any[])),i0.ɵmpd(512,i18.ResponseOptions,
              i18.BaseResponseOptions,([] as any[])),i0.ɵmpd(1024,i18.XSRFStrategy,
              i18.ɵb,([] as any[])),i0.ɵmpd(512,i18.XHRBackend,i18.XHRBackend,[i18.BrowserXhr,
              i18.ResponseOptions,i18.XSRFStrategy]),i0.ɵmpd(512,i18.RequestOptions,
              i18.BaseRequestOptions,([] as any[])),i0.ɵmpd(1024,i18.Http,i18.ɵc,[i18.XHRBackend,
              i18.RequestOptions]),i0.ɵmpd(1024,'BASE_URL',i1.getBaseUrl,([] as any[])),
          i0.ɵmpd(512,i15.ConfigService,i15.ConfigService,[i18.Http,'BASE_URL']),i0.ɵmpd(1024,
              i0.APP_INITIALIZER,(p0_0:any,p0_1:any,p1_0:any,p2_0:any) => {
                return [i10.ɵc(p0_0,p0_1),i12.ɵh(p1_0),i20.configServiceLoader(p2_0)];
              },[[2,i10.NgProbeToken],[2,i0.NgProbeToken],i12.ɵg,i15.ConfigService]),
          i0.ɵmpd(512,i0.ApplicationInitStatus,i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),
          i0.ɵmpd(131584,i0.ɵe,i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,
              i0.ComponentFactoryResolver,i0.ApplicationInitStatus]),i0.ɵmpd(2048,
              i0.ApplicationRef,(null as any),[i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,
              i0.ApplicationModule,[i0.ApplicationRef]),i0.ɵmpd(512,i10.BrowserModule,
              i10.BrowserModule,[[3,i10.BrowserModule]]),i0.ɵmpd(512,i18.HttpModule,
              i18.HttpModule,([] as any[])),i0.ɵmpd(512,i11.ɵba,i11.ɵba,([] as any[])),
          i0.ɵmpd(512,i11.FormsModule,i11.FormsModule,([] as any[])),i0.ɵmpd(512,i21.NvD3Module,
              i21.NvD3Module,([] as any[])),i0.ɵmpd(1024,i12.ɵa,i12.ɵd,[[3,i12.Router]]),
          i0.ɵmpd(512,i12.UrlSerializer,i12.DefaultUrlSerializer,([] as any[])),i0.ɵmpd(512,
              i12.ChildrenOutletContexts,i12.ChildrenOutletContexts,([] as any[])),
          i0.ɵmpd(256,i12.ROUTER_CONFIGURATION,{enableTracing:true},([] as any[])),
          i0.ɵmpd(1024,i9.LocationStrategy,i12.ɵc,[i9.PlatformLocation,[2,i9.APP_BASE_HREF],
              i12.ROUTER_CONFIGURATION]),i0.ɵmpd(512,i9.Location,i9.Location,[i9.LocationStrategy]),
          i0.ɵmpd(512,i0.Compiler,i0.Compiler,([] as any[])),i0.ɵmpd(512,i0.NgModuleFactoryLoader,
              i0.SystemJsNgModuleLoader,[i0.Compiler,[2,i0.SystemJsNgModuleLoaderConfig]]),
          i0.ɵmpd(1024,i12.ROUTES,() => {
            return [[{path:'',redirectTo:'island',pathMatch:'full'},{path:'island',
                component:i22.IslandEnergyComponent,canActivate:[i16.MsalGuard]},{path:'myenergy',
                component:i23.MyEnergyComponent,canActivate:[i16.MsalGuard]},{path:'dashboard',
                component:i24.MobileEnergyComponent,canActivate:[i16.MsalGuard]},{path:'login',
                component:i25.LoginComponent},{path:'logout',component:i26.LogoutComponent},
                {path:'**',redirectTo:'island'}]];
          },([] as any[])),i0.ɵmpd(1024,i12.Router,i12.ɵe,[i0.ApplicationRef,i12.UrlSerializer,
              i12.ChildrenOutletContexts,i9.Location,i0.Injector,i0.NgModuleFactoryLoader,
              i0.Compiler,i12.ROUTES,i12.ROUTER_CONFIGURATION,[2,i12.UrlHandlingStrategy],
              [2,i12.RouteReuseStrategy]]),i0.ɵmpd(512,i12.RouterModule,i12.RouterModule,
              [[2,i12.ɵa],[2,i12.Router]]),i0.ɵmpd(512,i27.AppModuleShared,i27.AppModuleShared,
              ([] as any[])),i0.ɵmpd(512,i1.AppModule,i1.AppModule,([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2FwcC9DbGllbnRBcHAvYXBwL2FwcC5icm93c2VyLm1vZHVsZS5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9hcHAvQ2xpZW50QXBwL2FwcC9hcHAuYnJvd3Nlci5tb2R1bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./$$_gendir/ClientApp/app/app.browser.module.ngfactory.ts